export const DASHBOARD_SUBTITLE =
  "View all your coaches in one place. Administer, edit, and print all current and archived surveys.";

export const CREATE_COACH_BUTTON_TEXT = "New Coach";

export const NO_RESULTS = "No coaches under selected season.";



// WEBPACK FOOTER //
// ./src/features/director/pages/dashboard/constants.ts